import {
  Configuration,
  CustomerResponse,
  CustomersApi,
  GetCustomerRequest
} from "collins-js-sdk";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler } from "../errorHandler";

/**
 * Get the customer from the API
 * @returns
 */
export const fetchCustomerFromAPI = async (
  params: GetCustomerRequest
): Promise<CustomerResponse> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const config = new Configuration({
    accessToken: token,
    basePath: environmentVars?.COLLINS_API_BASE_URL
  });

  try {
    const data = await new CustomersApi(config).getCustomer(params);
    return data ?? {};
  } catch (error) {
    errorHandler(error, "Error fetching customer details");

    return {};
  }
};
